module.exports = __webpack_public_path__ + "static/img/u0.85a0b71a.png";